module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_waso_house-c9c82a363be000dc675def8d95df0a71.jpg";